module.exports = __webpack_public_path__ + "SUZUKI-logo.png";